// extracted by mini-css-extract-plugin
export var deleteModal = "_rz-0";